import styled from "@emotion/styled";
import { multimediaEpaycoOrigin } from "../../../utils/multimedia";



export const colors = {
    title: "#8898AA",
    bgg: "#F4F5F7",
    label: "#525F7F",
    btn: "#40A8E6",
    btnH: "#0F85CB",
    black: "#000",
    alertG: "#67C940",
    alertR: "#E1251B",
    alertY: "#FFD100",
    naranja: "#F55806",
};


export const Campo = styled.div`
    width:100%;
    flex: ${props => props.flex};
    max-width:100%;

    .enviado{
        color:${colors.alertG};
        position:absolute;
        top:100%;
        left:0;
    }
    
    label{
      color: ${props => props.error ? colors.alertR : props.enviado ? colors.alertG : colors.label};
      font-size:14px;
      margin-bottom:5px;
      line-height:18px;
      text-align:${props => props.labelCenter ? "center" : "left"};
      div{
      display:inline-block;
      }
      i{
        color: ${colors.btn};
        margin-left:5px;
      }
    }
    
    input,select,textarea{
      height:${props => props.bordeAzul ? "35px" : "45px"};
      background:white;
      width:100%;
      padding: 0 .75em;
      border-radius:4px;
      border: ${props => props.bordeAzul ? "1px solid " + colors.btn : props.error && props.type !== "date" && props.type !== "time" ? "1px solid " + colors.alertR : "1px solid transparent"} ; 
      transition: all 500ms cubic-bezier(0.190, 1.000, 0.220, 1.000);
      box-shadow: 0 1px 3px rgba(0,0,0,.2);
      
        &:focus{
           outline:none;
        }
        
        &:disabled{
            background:#f1f1f2;
        }
    }
    
    .campo-error-icon{
        color:#e1251b;
        transform:rotate(90deg);
        right:20px;
        bottom:20px;
        position:absolute;
        height:20px;
        width:20px;
    }
    
    .campoTelefono{
        border: ${props => props.bordeAzul ? "1px solid " + colors.btn : props.error && props.type !== "date" && props.type !== "time" ? "1px solid " + colors.alertR : "1px solid transparent"} ;
        border-radius:4px;  
        
        input{
            max-width:100%;
            padding-left: 10px;
            border:1px solid red;
        }
    }
    
    input[type=number]::-webkit-inner-spin-button, 
    input[type=number]::-webkit-outer-spin-button { 
      -webkit-appearance: none; 
      margin: 0; 
    }
    
    input[type=number]::-webkit-outer-spin-button,
    input[type=number]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    
    input[type=number] {
        -moz-appearance:textfield;
    }
    
    .MuiFormControl-root{
          border: 2px solid ${props => props.error ? colors.alertR : "transparent"}; 
          border-radius:5px;      
    }
    
    select{
        background-image: url(${multimediaEpaycoOrigin}/dashboard/recaudo/proyecto/imagenes/arrowsSelect.png);
        background-position: 97% center;
        background-size: 14px auto;
        background-repeat:no-repeat;
        
        &:disabled{
            background:#f1f1f2;
            color:#999999;
        }
    }
    
     textarea{
        height:80px;
        resize:none;
         border: ${props => props.bordeAzul ? "1px solid " + colors.btn : props.error && props.type !== "date" && props.type !== "time" ? "1px solid " + colors.alertR : "1px solid transparent"} ;
        box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px;
        
        &:focus{
            outline:none;
            box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px;
            border:none;
        }
    }
`;
